<template>
    <div class="radio">
        <label :for="inputId">
            <input type="radio" name="shipping[pickup_location]" :id="inputId" class="required" :value="item.id">
            <strong>{{item.name}}</strong><br>
            <span v-html="description"></span>
        </label>
    </div>
</template>

<script>

import cloneDeep from "lodash/cloneDeep"

export default {
    name: "PickupLocation",
    props: {
        pristineItem: {
            type: Object,
            required: true,
        }
    },
    computed: {
        inputId() {
            return "pickup_location_id-" + this.item.id
        },
        description() {
            return this.item.description.replace(/\n/g, "<br>")
        }
    },
    data() {
        return {
            item: cloneDeep(this.pristineItem),
        }
    }
}

</script>


// WEBPACK FOOTER //
// item.vue?140b1236